import { render, staticRenderFns } from "./FriendsView.vue?vue&type=template&id=71294720&scoped=true&"
import script from "./FriendsView.vue?vue&type=script&lang=js&"
export * from "./FriendsView.vue?vue&type=script&lang=js&"
import style0 from "./FriendsView.vue?vue&type=style&index=0&id=71294720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71294720",
  null
  
)

export default component.exports